import axios from 'axios';
import URL_CONST from '../../../config/url';
import {getHeaders} from '../../../store/dataService';
import {BinaryStrategy, BinaryStrategyTypes} from './BinaryStrategyDto';

export type SceneDetectionStrategyContext = {
  sceneDetectorThreshold: number;
};

export class SceneDetectionStrategy extends BinaryStrategy {
  public sceneDetectorThreshold: number;

  static SCENE_DETECTOR_THRESHOLD_MIN = 0;
  static SCENE_DETECTOR_THRESHOLD_MAX = 1;
  static SCENE_DETECTOR_THRESHOLD_STEP = 0.01;
  static STRATEGY_NAME: BinaryStrategyTypes = 'Scene detection';

  constructor({sceneDetectorThreshold}: SceneDetectionStrategyContext) {
    super(SceneDetectionStrategy.STRATEGY_NAME);

    this.sceneDetectorThreshold =
      sceneDetectorThreshold ??
      (SceneDetectionStrategy.SCENE_DETECTOR_THRESHOLD_MIN +
        SceneDetectionStrategy.SCENE_DETECTOR_THRESHOLD_MAX) /
        2;
  }

  async generateImages(datasetId: string, binaryId: string): Promise<any> {
    if (!datasetId) {
      throw new Error('Dataset ID is required');
    }

    try {
      const headers = await getHeaders({
        'Request-Timeout': 3000,
      });
      const {data} = await axios.put(
        URL_CONST.DSS_DATASET_JOB,
        {
          type: 'VIDEO_SAMPLING',
          binaryId,
          sceneDetectorThreshold: this.sceneDetectorThreshold,
        },
        {
          params: {datasetId},
          headers,
        }
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
